<template>
  <div class="school">
    <div class="content-wrapper">
      <div class="schoolNow-wrapper" v-if="schoolNow">
        <img class="img" :src="computeUrl(schoolNow.faceimg)" alt="school-cover">
        <div class="info-wrapper">
          <h2 class="title">{{decodeURIComponent(schoolNow.roomname)}}</h2>
          <p class="type">{{decodeURIComponent(schoolNow.roomtypename)}}</p>
          <button class="btn" @click="showSwitchSchool">切换网校</button>
          <!--<button class="btn" @click="showShareSchool">分享网校</button>-->
          <span class="identity" v-if="schoolNow.iscreator===1">我的网校</span>
          <span class="identity" v-else-if="schoolNow.ismanager===1">我是管理员</span>
          <span class="identity" v-else>我是老师</span>
        </div>
      </div>
      <div class="brief">
        <div class="float">
          <p class="title">总报名</p>
          <p class="num">{{enrollnums}}</p>
        </div>
        <div class="float">
          <p class="title">总收入</p>
          <p class="num">{{income}}</p>
        </div>
      </div>
      <div class="brief no-margin">
        <p class="test-title">测试上课设备</p>
        <p class="para1">为了保证您能正常上课</p>
        <p class="para1">需要检测您的摄像头、扬声器是否正常</p>
        <button class="test-btn" @click="openTestUrl">开始测试</button>
      </div>
      <!--<div class="schedule-wrapper">-->
        <!--<el-tabs type="card" v-model="selectTab" @tab-click="handleClick" class="nav-hooker">-->
          <!--<el-tab-pane label="试听课" name="1"></el-tab-pane>-->
          <!--<el-tab-pane label="正式课" name="0"></el-tab-pane>-->
        <!--</el-tabs>-->
        <!--<div class="list-wrapper">-->
          <!--<div class="list-item" v-for="(item,index) in list">-->
            <!--<div class="item-top">-->
              <!--<img v-if="item.items[0].democlass==='1'"-->
                   <!--src="./corner.png"-->
                   <!--alt="试听班标识" width="50" height="50" class="img-corner">-->
              <!--<div class="item-img-wrapper">-->
                <!--<img :src="imgprefix+item.items[0].lessonfaceimg" alt="课程图片" width="90" height="60">-->
              <!--</div>-->
              <!--<div class="class-content-wrapper">-->
                <!--<p class="main-title" @click="gotoClassSchedule(item.items[0])">-->
                  <!--《{{decodeURIComponent(item.items[0].lessonname)}}》</p>-->
                <!--<p class="sub-title" @click="gotoClassSchedule(item.items[0])">-->
                  <!--{{decodeURIComponent(item.items[0].classmodename)}}-{{decodeURIComponent(item.items[0].classname)}}</p>-->
              <!--</div>-->
              <!--<div class="enrollnums-wrapper">-->
                <!--<p class="enrollnums"-->
                   <!--@click="showEnrollPeople(item)"-->
                   <!--v-if="item.items[0].democlass=='1'"-->
                   <!--:class="{'allow':item.items[0].enrollnums!=null}">-->
                  <!--{{item.items[0].enrollnums}}人参与>-->
                <!--</p>-->
                <!--<p class="enrollnums"-->
                   <!--@click="showEnrollPeople(item)"-->
                   <!--v-else>查看报名人数</p>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item-bottom">-->
              <!--<template v-for="(ele,index2) in item.items">-->
                <!--<div class="mulu-item">-->
                  <!--<div class="time-wrapper" @click="getCourseWare(index,index2,ele)">-->
                    <!--<span class="arrow" :class="{show:ele.show}"></span>-->
                    <!--<span class="date">{{ele.planstarttime.substring(0, 10)}}</span>-->
                    <!--<span-->
                      <!--class="time">{{ele.planstarttime.substring(11, 16)}}-{{ele.planendtime.substring(11, 16)}}</span>-->
                  <!--</div>-->
                  <!--<span class="mulu-name">{{decodeURIComponent(ele.catalogname)}}</span>-->
                  <!--<div class="mulu-operate-wrapper">-->
                    <!--<button class="mulu-btn delete" @click="showAddWare(ele)">添加课件</button>-->
                    <!--<button class="mulu-btn live" @click="gotoLive(ele)">进入上课</button>-->
                    <!--&lt;!&ndash;<div class="mulu-more">更多设置&ndash;&gt;-->
                    <!--&lt;!&ndash;<ul>&ndash;&gt;-->
                    <!--&lt;!&ndash;<li @click="showChangeTime(ele)">修改上课时间</li>&ndash;&gt;-->
                    <!--&lt;!&ndash;<li v-if="ele.democlass=='1'" @click="delMulu(ele)">删除本次试听</li>&ndash;&gt;-->
                    <!--&lt;!&ndash;</ul>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->

                  <!--</div>-->
                <!--</div>-->
                <!--<div class="wareList-wrapper" v-if="ele.show">-->
                  <!--<template v-if="!isEmpty(ele.coursewarelist)">-->
                    <!--<div class="ware-item" v-for="(data,index3) in ele.coursewarelist">-->
                      <!--<div class="ware-img-wrapper">-->
                        <!--<img :src="imgprefix+data.faceimg" alt="课件封面" width="60" height="40">-->
                      <!--</div>-->
                      <!--<p class="courseware-name">{{decodeURIComponent(data.coursewarename)}}</p>-->
                      <!--<section class="courseware-btn-wrapper">-->
                        <!--<button class="courseware-btn transparent" @click="previewWare(data)">预览</button>-->
                        <!--<button class="courseware-btn transparent" @click="editWare(data)">编辑</button>-->
                        <!--<button class="courseware-btn del" @click="delWare(data,index,index2,index3)">删除</button>-->
                      <!--</section>-->
                    <!--</div>-->
                  <!--</template>-->
                  <!--<p v-else style="text-align:center;font-size: 16px;color:#666;font-weight:bold">暂无课件</p>-->
                <!--</div>-->
              <!--</template>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <pop-dialog ref="switchSchool" title="切换网校" class="switch-school">
      <div slot="content" class="switch-content">
        <span class="school-avatar">
          <img src="./avatar.png" alt="avatar" width="70" height="70">
          <p v-if="schoolNow">{{decodeURIComponent(schoolNow.roomname)}}</p>
        </span>
        <span class="switch">
          <img src="./switch.png" alt="switch" width="80" height="25">
        </span>
        <div class="changelist-wrapper" v-if="schoollist">
          <span class="school-avatar" v-for="item in schoollist" @click="switchSchool(item)">
          <img src="./avatar.png" alt="avatar" width="70" height="70">
          <p>{{decodeURIComponent(item.roomname)}}</p>
          </span>
        </div>
      </div>
    </pop-dialog>
    <!--分享网校二维码-->
    <share-school-page ref="shareschool"
                       :schoolinfo="schoolNow"
                       title="分享网校"></share-school-page>
    <!--复制班级弹出框-->
    <changetime-pop ref='popcopy' :scheduleInfo="scheduleInfo" @confirm="confirmChangeTime"></changetime-pop>
    <div class="warePop" v-if="warePopShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">选择课件</h3>
        <div class="flex-wrapper">
          <p class="left">已选择：{{count}}个</p>
          <p class="right" @click="gotoMake">制作新课件</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in lessonWareList">
            <div class="classware">
              <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="80" height="60">
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.coursewarename)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.introduce)}}</p>
              </div>
              <img v-if="item.show===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.show===true"
                   @click="item.show=false;count--"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="warePopShow=false;">取消</button>
            <button class="confirm" @click="addWare">确认</button>
          </div>
        </div>
      </div>
    </div>
    <div class="newpop-mask" v-if="newShow">
      <div class="newpop">
        <h2 class="new-title">添加课件</h2>
        <img class='close'
             @click="newShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <div class="block btn1" @click="showExistedWare">
          <img class='img' src="./btn1.png" alt="add" width="30" height="30">
          <span class="text">选择已有课件</span>
        </div>
        <div class="block btn2">
          <img class='img' src="./btn2.png" alt="add" width="30" height="30">
          <span class="text">添加PDF文件</span>
          <input class="input-file"
                 type="file"
                 accept=".pdf"
                 @change="upFile">
        </div>
      </div>
    </div>
    <div class="enrollpop-wrapper" v-if="enrollShow">
      <div class="enrollpop">
        <h2 class="title">报名列表</h2>
        <h3 class="sub-title">共{{enrollTotal}}人报名</h3>
        <img class='close'
             @click="enrollShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <table class="table">
          <tr class="tr-title">
            <th class="th">上课日期</th>
            <th class="th">学员</th>
            <th class="th">电话</th>
            <th class="th">报名时间</th>
          </tr>
          <template v-for="item in enrollList">
            <tr class="tr-content">
              <td class="td">{{item.startdate.substring(0, 11)}}</td>
              <td class="td">{{decodeURIComponent(item.username)}}</td>
              <td class="td">{{decodeURIComponent(item.phone)}}</td>
              <td class="td">{{decodeURIComponent(item.addtime).substring(0, 16)}}</td>
            </tr>
          </template>

        </table>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import popDialog from 'components/popdialog/PopDialog'
  import shareSchoolPage from 'components/shareschoolpage/ShareSchoolPage'
  import Vue from 'vue';
  import changetimePop from 'components/changetimepop/ChangeTimePop'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: null,
        schoollist: null,
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //-------------以下内容和今日报名、今日收入有关------------//
        enrollnums: 0,
        income: 0,
        //-----------以下内容和筛选有关-----------//
        selectTab: '1',
        //-----------以下内容和课程表有关-----------//
        list: [],
        //--------报名列表----------//
        enrollShow: false,
        enrollTotal: 0,
        enrollList: [],

        //--------修改时间----------//
        bShow: false,
        timeValue: new Date(2016, 9, 10, 8, 30),
        scheduleInfo: null,
        //添加课件
        newShow: false,
        //--------添加PDF----------//
        fileName: '',
        loading: null,
        //--------选择已有课件----------//
        warePopShow: false,
        count: 0,
        lessonWareList: [],
        classScheduleNow: null,
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeUrl(url){
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //显示切换网校弹框
      showSwitchSchool(){
        this.selectShow = false;
        this.$refs.switchSchool.show();
      },
      showShareSchool(){
        this.$refs.shareschool.show();
      },
      //点击某个网校
      switchSchool(item){
        this.schoolNow = item;
        saveLocal('schoolNow', item);
        this.$refs.switchSchool.hide();
        //根据conputeXHRParams确定XHR请求的参数，再异步请求数据
        this.currentPage = 1;
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        //获取报名人数和收入
        this.RoomInfoByRid();
      },
      openTestUrl(){
        window.open('https://edu.9man.com/liveroom/device.html');
      },
      //跳至班级的课件管理处
      gotoClassSchedule(item){
        const loading = this.$loading({
          lock: true,
          text: '添加中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let done1 = false, done2 = false;
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryOneLesson',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            done1 = true;
            saveLocal('lessoninfo', response.list[0])
            if (done1 && done2) {
              loading.close();
              this.$router.push('/console/lesson/class/schedule')
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryClass',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            done2 = true;
            saveLocal('classinfo', response.list[0])
            if (done1 && done2) {
              loading.close();
              this.$router.push('/console/lesson/class/schedule')
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      showEnrollPeople(item){
        if (item.items[0].enrollnums != '0') {
          this.QueryClassUser(item.items[0]);
          this.enrollShow = true;
        }
      },
      QueryClassUser(item){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassUser',
            a: 'QueryClassUser',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            pageno: 1,
            pagesize: 100,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.enrollList = response.list;
            this.enrollTotal = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //显示添加课件
      showAddWare(ele){
        this.newShow = true;
        this.classScheduleNow = ele;
      },
      showExistedWare(){
        this.lessonWareList = [];
        this.newShow = false;
        this.warePopShow = true;
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: this.classScheduleNow.rid,
            lessonid: this.classScheduleNow.lessonid,
            pageno: 1,
            pagesize: 300,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.lessonWareList = response.list;
          if (this.lessonWareList != null) {
            this.lessonWareList.forEach(function (ele) {
              ele.show = false;
            })
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      upFile(e){
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        this.fileName = file.name;
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
        this.newShow = false;
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'ImportCourseWareFromImages',
            id: this.id,
            rid: this.classScheduleNow.rid,
            lessonid: this.classScheduleNow.lessonid,
            classid: this.classScheduleNow.classid,
            classcatalogid: this.classScheduleNow.classcatalogid,
            coursewarename: this.fileName,
            uploadfilename: jsonobj.image
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let params = this.conputeXHRParams(1);
            this.loadList(params);
            this.loading.close();
          } else {
            this.loading.close();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //添加课件
      gotoMake(){
        this.$alert('请前往‘课程列表’-‘课件/备课’处设置', '提示', {
          confirmButtonText: '确定',
        });
      },
      show(item, index){
        Vue.set(this.lessonWareList[index], 'show', true);
        this.count++;
        this.$forceUpdate();
      },
      addWare(){
        if (this.lessonWareList == null) {
          this.warePopShow = false;
          return;
        }
        let list = [];
        //根据lessonWareList中每个项的show是否为true，将其添加到list中
        for (let i = 0; i < this.lessonWareList.length; i++) {
          if (this.lessonWareList[i].show === true) {
            list.push(this.lessonWareList[i]);
          }
        }
        if (list.length === 0) {
          this.$message({
            message: '请选择相应的课件',
            type: 'waring',
          })
        } else {
          const loading = this.$loading({
            lock: true,
            text: '添加中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let count = 0;
          for (let i = 0; i < list.length; i++) {
            //接口：添加课件到对应的课程目录
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'ClassCourseWare',
                a: 'AddClassCourseWare',
                id: this.id,
                rid: this.classScheduleNow.rid,
                lessonid: this.classScheduleNow.lessonid,
                classid: this.classScheduleNow.classid,
                coursewareid: list[i].sceneid,
                classcatalogid: this.classScheduleNow.classcatalogid,
                coursewarename: list[i].coursewarename,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              }
              if (response.code === 200 || response.code === 102) {
                count++;
                if (count === list.length) {
                  loading.close();
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.warePopShow = false;
                  let params = this.conputeXHRParams(1);
                  this.loadList(params);
                  this.$forceUpdate();
                }
              }
            }).catch((err) => {
              this.$alert('请求失败，请重试', '提示', {
                confirmButtonText: '确定',
              });
              loading.close();
            });
          }
        }
      },
      //打开修改时间
      showChangeTime(ele){
        this.scheduleInfo = ele;
        this.$refs.popcopy.show();
      },
      confirmChangeTime(){
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      //删除指定课程表
      delMulu(item){
        this.$confirm('是否删除本次试听?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'ClassSchedule',
              a: 'DeleteClassSchedule',
              id: this.id,
              rid: item.rid,
              lessonid: item.lessonid,
              scheduleid: item.id,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              let params = this.conputeXHRParams(1);
              this.loadList(params);
              this.$forceUpdate();
            }
          }).catch((err) => {
            this.$alert('请求失败，请重试', '提示', {
              confirmButtonText: '确定',
            });
          });
        }).catch(() => {
        });
      },
      //编辑课件
      editWare(item){
        window.open(`${this.GLOBAL.editUrl}indexapp.php#/scene/create/${item.coursewareid}?pageId=1&sid=${this.id}`)
      },
      //预览课件和分享课件(预览和分享是同一个功能)
      previewWare(item){
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
      delWare(item, index, index2, index3){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'DeleteClassCourseWare',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            coursewareid: item.coursewareid,
            classcatalogid: item.classcatalogid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let tempList = this.list[index].items[index2].coursewarelist;
            tempList.splice(index3, 1);
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$forceUpdate()
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        });
      },
      //-------------------进入直播间---------------------------//
      gotoLive(item){
        let id = this.id;
        let classid = item.classid;
        let rid = item.rid;
        let lessonid = item.lessonid;
        let catalogindex = item.catalog_index;
        let catalogid = item.classcatalogid;
        window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      getCourseWare(index, index2, ele){
        let item = this.list[index].items[index2];
        if (item.show === false) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'ClassCourseWare',
              a: 'QueryClassCourseWare',
              id: this.id,
              classcatalogid: item.classcatalogid,
              pageno: 1,
              pagesize: 200,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              item.coursewarelist = response.list;
//              Vue.set(item, coursewarelist, response.list);
              this.$forceUpdate();
            }
          }).catch((err) => {
            this.$alert('未获取到数据，请重新加载页面', '提示', {
              confirmButtonText: '刷新',
              callback: action => {
                window.location.reload();
              }
            });
          });
        }
        this.list[index].items[index2].show = !this.list[index].items[index2].show;
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber){
        let params = {
          c: 'ClassSchedule',
          a: 'QueryClassSchedule',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          pageno: pageNumber,
        };
        //对应后台，1位试听课，0位收费课
        if (this.selectTab === '1') {
          params.democlass = 1;
        } else if (this.selectTab === '0') {
          params.democlass = 0;
        }
        return params;
      },
      //获取课程表列表
      loadList(params){
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              let element = list[i].items;
              for (let j = 0; j < element.length; j++) {
                element[j].show = false;
                element[j].coursewarelist = null;
              }
            }
            this.list = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      handleClick(tab, event){
        if (tab.name === '1') {
          this.selectTab = '1';
        } else if (tab.name === '0') {
          this.selectTab = '0';
        }
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      //改变页码时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(val);
        this.loadList(params);
        this.$forceUpdate();
      },
      RoomInfoByRid(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'RoomInfoByRid',
            id: this.id,                //sessionid
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let schoolInfo = response.list[0];
            this.enrollnums = schoolInfo.payusercounts;
            this.income = schoolInfo.totalpays;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      QueryManagerRooms(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'QueryManagerRooms',
            id: this.id
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          //code返回101时表示没有网校
          if (response.code === 101) {
            //如果没有网校，说明该用户注册老师时，只是完成了第一步，并没有填写教师资料，因此没有创建网校
            this.$router.replace('/fillin');
          }
          if (response.code === 200) {
            let list = response.list;
            saveLocal('schoollist', list);
            this.schoollist = list;
            this.schoolNow = list[0];
            saveLocal('schoolNow', this.schoolNow);
            //根据conputeXHRParams确定XHR请求的参数，再异步请求数据
            let params = this.conputeXHRParams(1);
            this.loadList(params);
            //获取报名人数和收入
            this.RoomInfoByRid();
            this.loadLessonList();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      loadLessonList(){
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLesson',
            id: this.id,                //sessionid
            queryrid: this.schoolNow.rid,              //网校id
            pageno: 1,
            pagesize: 2
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.list == null) {
            this.$alert('还差"创建课程"这一步，完成就可以招生赚钱了，请创建课程', '提示', {
              confirmButtonText: '确定',
            }).then(() => {
              this.$router.push('/console/lesson?open=true');
            }).catch(() => {
            })
          }
        }).catch((err) => {
        })
      },
    },
    created(){
      this.QueryManagerRooms();
    },
    components: {
      popDialog,
      shareSchoolPage,
      changetimePop
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .el-tabs__nav
    z-index: 0
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .school
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    position relative
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .schoolNow-wrapper, .brief
        display: inline-block
        height: 160px
        margin-right: 10px
        background #ffffff
        border: 1px solid #e4e4e4
        box-sizing: border-box
        vertical-align top
        position relative
      .schoolNow-wrapper
        width: 398px
        padding: 29px 0 29px 20px
        .img
          float: left
          width: 102px
          height: 102px
          border: 1px solid #e4e4e4
          box-sizing: border-box
        .info-wrapper
          float: left
          margin-left: 20px
          width: 254px
          .title
            width: 100%
            line-height: 30px
            font-size: 20px
            color: #000000
            font-weight: bold
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          .type
            line-height: 18px
            margin: 8px 0 18px
            font-size: 13px
            color: #000
          .btn
            margin-right: 10px
            height: 28px
            line-height: 28px
            width: 70px
            border-radius: 4px
            text-align: center
            font-size: 14px
            color: #ffffff
            background #3399ff
          .identity
            font-size: 12px
            color: #999
      .brief
        width: 374px
        &.no-margin
          margin: 0
          padding-top: 30px
          text-align :center
          .test-title
            font-size: 14px
            color: #333333
            line-height: 14px
            margin-bottom: 16px
          .para1,.para2
            font-size: 12px
            color: #666666
            line-height: 12px
          .para1
            margin-bottom: 12px
          .para2
            margin-bottom: 16px
          .test-btn
            margin:0 auto
            display:block
            width: 90px
            height: 30px
            line-height: 30px
            color: #ffffff
            font-size: 14px
            background :#3399ff
            border-radius :4px
        .float
          float: left
          width: 50%
          height: 130px
          margin: 15px 0
          text-align: center
          border-right: 1px solid #e4e4e4
          box-sizing: border-box
          &:last-child
            border: none
          .title
            margin: 15px 0 58px 0
            line-height: 18px
            font-size: 14px
            color: #555
          .num
            font-size: 24px
            color: #000000
            font-weight: bold
            line-height: 24px
      .schedule-wrapper
        margin-top: 20px;
        padding-bottom: 20px
        background: #ffffff
        .list-wrapper
          padding-top: 35px
          .list-item
            margin: 0 35px 20px
            border-radius: 4px
            box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1)
            .item-top
              height: 90px
              background: #81A1C1
              position: relative
              .img-corner
                position: absolute
                top: 0
                left: 0
              .item-img-wrapper
                float: left
                margin: 15px 10px 0 30px
              .class-content-wrapper
                float: left
                margin-top: 15px
                height: 60px
                .main-title
                  height: 30px
                  line-height: 30px
                  font-size: 16px
                  color: #ffffff
                  font-weight: bold
                  cursor: pointer
                  &:hover
                    text-decoration: underline
                .sub-title
                  margin-left: 5px
                  height: 30px
                  line-height: 30px
                  font-size: 14px
                  color: #ffffff
                  cursor: pointer
                  &:hover
                    text-decoration: underline

              .enrollnums-wrapper
                float: right
                margin: 45px 15px 0 0
                .enrollnums
                  height: 30px
                  line-height: 30px
                  font-size: 14px
                  color: #ffffff
                  &.allow
                    cursor: pointer
            .item-bottom
              .mulu-item
                height: 70px
                border-bottom: 1px solid #e4e4e4
                &:last-child
                  border: none
                .time-wrapper
                  display: inline-block
                  width: 270px
                  height: 70px
                  line-height: 70px
                  position: relative
                  cursor: pointer
                  .arrow
                    position absolute
                    left: 15px
                    top: 28px
                    display: inline-block
                    width: 8px
                    height: 8px
                    border-left: 1px solid #333
                    border-bottom: 1px solid #333
                    transform: rotate(-45deg)
                    transition-duration 300ms
                    &.show
                      transform: rotate(135deg)
                      top: 30px
                  .date
                    margin-left: 45px
                    font-size: 18px
                    color: #000000
                    font-weight: bold
                  .time
                    margin-left: 10px
                    font-size: 12px
                    color: #000000
                .mulu-name
                  font-size: 15px
                  color: #000000
                .mulu-operate-wrapper
                  float: right
                  margin: 20px 15px 0 0
                  height: 30px
                  .mulu-btn
                    display: inline-block
                    width: 90px
                    height: 30px
                    line-height: 30px
                    font-size: 13px
                    color: #fff
                    margin-right: 10px
                    border-radius: 4px
                    &:last-child
                      margin-right: 15px
                  .delete
                    background: #3399ff
                  .live
                    background: #33cc33
                  .mulu-more
                    display: inline-block
                    width: 70px
                    line-height: 30px
                    font-size: 12px
                    color: #999
                    cursor: pointer
                    position: relative
                    &:hover
                      color: #3399ff
                    &:hover ul
                      display: block
                    ul
                      display: none
                      position: absolute
                      right: 0
                      top: 100%
                      width: 108px
                      background: #ffffff
                      box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
                      z-index: 100
                      li
                        font-size: 12px
                        color: #000000
                        height: 35px
                        line-height: 35px
                        text-align: center
                        border-bottom: 1px solid #e4e4e4
                        &:last-child
                          border: none
              .wareList-wrapper
                padding: 20px 30px
                background: #e4e4e4
                .ware-item
                  height: 60px
                  background: #ffffff
                  border-radius: 4px
                  margin-bottom: 10px
                  &:last-child
                    margin: 0
                  .ware-img-wrapper
                    float: left
                    width: 60px
                    height: 40px
                    margin: 10px 0 0 15px
                  .courseware-name
                    margin-left: 10px
                    float: left
                    line-height: 60px
                    font-size: 14px
                    color: #000
                  .courseware-btn-wrapper
                    float: right
                    height: 28px
                    margin: 16px 15px 0 0
                    .courseware-btn
                      height: 28px
                      width: 60px
                      font-size: 14px
                      box-sizing: border-box
                      text-align: center
                      border-radius: 4px
                      &.transparent
                        margin-right: 10px
                        line-height: 26px
                        color: #666666
                        border: 1px solid #d7d7d7
                        background: #fafafa
                      &.del
                        line-height: 28px
                        background #ff6666
                        color: #fff
    .switch-school
      .switch-content
        padding: 50px 85px
        .school-avatar
          display: inline-block
          margin-right: 30px
          width: 100px
          height: 116px
          font-size: 0
          text-align: center
          vertical-align: top
          cursor: pointer
          img
            border-radius: 4px
          p
            margin-top: 10px
            font-size: 14px
            line-height: 18px
            height: 36px
            color: #000000
            text-align: center
            overflow: hidden //必须http://www.cnblogs.com/zhunrong/p/6628828.html
            display: -webkit-box //必须
            -webkit-line-clamp: 2 //必须
            -webkit-box-orient: vertical
        .switch
          display: inline-block
          height: 70px
          line-height: 84px
          vertical-align: top
        .changelist-wrapper
          display: inline-block
          padding-left: 30px
          max-width: 220px
          font-size: 0
          .school-avatar
            margin: 0 20px 10px 0
            &:nth-child(2n)
              margin: 0
    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      z-index 300
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            font-size: 14px
            color: #3399ff
            line-height: 19px
            cursor: pointer
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              vertical-align top
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-top: 12px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              position relative
              top: 20px
              margin-left: 20px
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

    .newpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .newpop
        margin: auto
        padding: 30px 60px 60px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .new-title
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .block
          margin-top: 20px
          padding: 0 35px
          height: 80px
          line-height: 80px
          border-radius: 4px
          cursor: pointer
          .img
            position relative
            top: 10px
          .text
            display inline-block
            width: 150px
            height: 80px
            line-height: 80px
            text-align: center
            font-size: 16px
            color: #ffffff
        .btn1
          margin-top: 40px
          background #3399ff
        .btn2
          background: #33cc33
          position relative
          .input-file
            position: absolute
            left: 0
            top: 0
            right: 0
            bottom: 0
            width: 100%;
            height: 100%;
            padding: 0
            margin: 0
            opacity: 0
            cursor: pointer
    .enrollpop-wrapper
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .enrollpop
        margin: auto
        width: 820px
        padding: 30px 60px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .title
          margin-bottom: 15px
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .sub-title
          margin-bottom: 10px
          font-size: 14px
          color: #000000
          height: 20px
          line-height: 20px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .table
          width: 700px
          background: #ffffff
          text-align: center
          font-size: 0
          table-layout: fixed
          border: 1px solid #e4e4e4
          .tr-title
            .th
              height: 40px
              line-height: 40px
              width: 175px
              font-size: 14px
              color: #fff
              background: rgba(0, 0, 0, 0.8)
              box-sizing: border-box
              border-right: 1px solid #fff
              &:last-child
                border: none
          .tr-content
            border-bottom: 1px solid #e4e4e4
            &:last-child
              border: none
            .td
              height: 40px
              line-height: 40px
              width: 233px
              font-size: 14px
              color: #000
              border-right: 1px solid #e4e4e4
              &:last-child
                border: none
</style>




// WEBPACK FOOTER //
// src/page/school/schoolinfo/SchoolInfo.vue